// @flow
/* eslint-disable import/prefer-default-export */
import { ApiBase } from 'api/api'
import { makeGetDownloadRequest, makeGetRequest } from 'api/fetchCalls'
import FileSaver from 'file-saver'
import type { ExportFileResponse, ExportParams } from 'types/exports'

export async function getExportFiles(
  export_id: string,
  { page = 1, pageSize = 10, search }: ExportParams = {},
  requestParams: { signal?: AbortSignal } = {}
): Promise<ExportFileResponse> {
  return await makeGetRequest(
    ApiBase +
      `/exports/${export_id}/files?page=${page}&page_size=${pageSize}` +
      (search ? `&search=${search}` : ''),
    requestParams
  )
}

export async function getExportFile({ id }: { id: string }): Promise<void> {
  const url = `${ApiBase}/exports/files/${id}`
  const [filename, blob] = await makeGetDownloadRequest(url)
  FileSaver.saveAs(blob, decodeURIComponent(filename.replace(/"/g, '')))
}
